import React from 'react'

import { BaseItemsByOrganizationWidget } from './BaseItemsByOrganizationWidget'

export const ItemsByOrganizationWidget = () => {
  return <BaseItemsByOrganizationWidget section="checklist" loadingKey="checklistPage" />
}
